
<template>
      <div class="w-full h-full min-h-screen bg-blue-200 flex">

        <!-- sidebar content -->
        <div class="h-full fixed">
          	<side-bar  v-on:toggle-sidebar-drawer="toggleSidebarDrawer"/>
        </div>

        <div class="w-full  transition-all duration-700 ease-in-out " :class="opendrawer? 'ml-48':'ml-12'">
          
          	<!-- Account -->
		    <div class="flex  justify-between items-center w-full px-4 md:px-8 pt-4">
              <div>
              <span class="text-2xl md:text-2xl text-darkblue "> Hello {{user.name}}</span>
              <br>
              <span class="text-1xl md:text-xl text-blue-600 "> Member ID - {{user.id}}</span>
              </div>
            	<account/>
          	</div>
          
			<!-- Main content -->
			<div class="px-4 md:px-8">
				<slot />
			</div>
          
        </div>

      </div>  
  
</template>

<script>
  import Sidebar from './Sidebar'
  import Account from './Account'

  import { computed } from 'vue'
  import { usePage } from '@inertiajs/inertia-vue3'
  export default {
    setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
	data(){
        return{
            opendrawer:true,
        }
    },
    components:{
      'side-bar':Sidebar,
      'account' :Account,
    },
     created(){
         this.$store.dispatch('authentication/getToken',{"email": this.user.email,"id": this.user.id})
    },

  //  computed:{
  //       // user () {
  //       //     return this.$store.state.authentication.user
  //       // },
         
  //   },
	methods:{
		toggleSidebarDrawer(value) {
				this.opendrawer=value;
            }
	}
  }
</script>

<style scoped>


</style>
